import React from 'react'
import GoBack from '../../../components/GoBack'
import Header from '../../../components/Header'
import IncompleteProfilesTable from '../../../tables/Farmers/IncompleteProfilesTable'

const IncompleteProfiles = () => {
  return (
    <div>
      <div>
        <GoBack />
      </div>

      <div className="mt-[14px] mb-6">
        <Header text="Incomplete Profiles" />
      </div>

      <div>
        <IncompleteProfilesTable />
      </div>
    </div>
  )
}

export default IncompleteProfiles
